import { RhcField } from 'features/generator/components/RhcField'
import { useSetAtom } from 'jotai'
import { useTranslations } from 'next-intl'
import { useFormContext } from 'react-hook-form'

import { TVideoButton, TVideoInfoFields } from '../VideoInfoFormModel'
import { videoButtonListAtom } from './ButtonsSection'

export const ButtonTextField = ({
	index,
	buttonList,
}: {
	index: number
	buttonList: TVideoButton[]
}) => {
	const t = useTranslations()

	const form = useFormContext<TVideoInfoFields>()

	const setButtonList = useSetAtom(videoButtonListAtom)

	const setValue = (value?: string) => {
		if (value !== undefined) {
			setButtonList((prev) => {
				const newValue = [...prev]
				newValue[index]!.title = value
				return newValue
			})
		}
	}

	return (
		<RhcField
			type="text"
			form={form}
			path={`buttons.${index}.title`}
			value={buttonList[index]!.title}
			setValue={setValue}
			fieldName="button_title"
			fieldGroup="buttons"
			label={t(
				'generator__content_form_section__videos_information__button_text__label',
			)}
			placeholder={t(
				'generator__content_form_section__videos_information__button_text__placeholder',
			)}
			className="w-full tablet:grow"
		/>
	)
}

export const ButtonUrlField = ({
	index,
	buttonList,
}: {
	index: number
	buttonList: TVideoButton[]
}) => {
	const t = useTranslations()

	const form = useFormContext<TVideoInfoFields>()

	const setButtonList = useSetAtom(videoButtonListAtom)

	const setValue = (value?: string) => {
		if (value !== undefined) {
			setButtonList((prev) => {
				const newValue = [...prev]
				newValue[index]!.url = value
				return newValue
			})
		}
	}

	return (
		<RhcField
			type="url"
			form={form}
			path={`buttons.${index}.url`}
			value={buttonList[index]!.url}
			setValue={setValue}
			fieldName="button_url"
			fieldGroup="buttons"
			label={t(
				'generator__content_form_section__videos_information__button_url__label',
			)}
			placeholder={t(
				'generator__content_form_section__videos_information__button_url__placeholder',
			)}
			className="grow tablet:w-full"
		/>
	)
}
